import { css } from '@emotion/core'
import { mediumUp } from 'Utils'
import theme from 'Theme'

const { colors, typography, spacing, mixins } = theme

const { mainContainerTopPadding, loadingLight, defaultButton } = mixins

export default css`
  ${mainContainerTopPadding(theme)}
  min-height: 50vh;
  .favourites__content {
    width: 90%;
    max-width: 760px;
    margin: 0 auto;
  }

  .favourites__heading {
    text-transform: uppercase;
    text-align: center;
    font-weight: normal;
    font-size: ${typography.sizes.larger};
    margin-bottom: ${spacing.base_1}px;
  }

  .sub-heading {
    text-align: center;
    font-weight: normal;
  }

  .favourite__removebtn {
    ${defaultButton(theme)}
    min-width: auto;
    padding: 0.75rem;
    border: 1px solid ${theme.colors.lightGrey};
    svg {
      fill: ${theme.colors.lightGrey};
    }
    &:hover {
      border-color: ${theme.colors.primary};
      background-color: ${theme.colors.bodyBackground};
      svg {
        fill: ${theme.colors.primary};
      }
    }
  }

  .favourite {
    margin: ${spacing.base_4}px 0 ${spacing.base_4}px 0;
    padding-bottom: ${spacing.base_4}px;
    border-bottom: 1px solid ${colors.borderGrey};
    display: grid;
    grid-template-columns: 40% 1fr;
    grid-template-areas:
      'imagewrapper title'
      'imagewrapper price'
      'imagewrapper 1fr'
      'imagewrapper remove';

    @media ${mediumUp} {
      grid-template-columns: 25% 40% 1fr;
      grid-template-areas:
        'imagewrapper title price'
        'imagewrapper 1fr remove';
    }

    &.card--loading {
      grid-gap: ${spacing.base_4}px;
      grid-template-columns: 25% 1fr;
      grid-template-areas:
        'imagewrapper loading-content'
        'imagewrapper loading-sub'
        'imagewrapper 1fr';

      .favourite__imagewrapper {
        ${loadingLight(theme)}
        border: none;
      }
      border-bottom: 1px solid ${colors.cardGrey};
    }
    &.oos {
      border-bottom: none;
      padding-bottom: 0px;
      margin-bottom: ${spacing.base_3}px;
      .favourite__imagewrapper {
        background-color: ${colors.bodyBackground};
      }
    }
  }

  .oos__product {
    padding: ${spacing.base_3}px;
    margin-bottom: ${spacing.base_3}px;
    background-color: ${colors.cardGrey};
    border-bottom: none;
  }
  .oos__title {
    font-size: 1.2rem;
    margin-bottom: ${spacing.base_2}px;
  }
  .oos__sub-title {
    margin-bottom: ${spacing.base_3}px;
  }

  .loading__content {
    grid-area: loading-content;
    ${loadingLight(theme)}
    height: 50px;
  }

  .loading-content-sub {
    grid-area: loading-sub;
    ${loadingLight(theme)}
    max-width: 300px;
    height: 50px;
  }

  .heading--loading {
    height: ${spacing.base_4}px;
    ${loadingLight(theme)}
    max-width: 300px;
    margin: 0 auto ${spacing.base_4}px auto;
  }

  .favourite__buybtn {
    min-width: auto;
    padding: 0.75rem 2rem;
    font-size: ${typography.sizes.small};

    @media ${mediumUp} {
      padding: 0.75rem 3rem;
    }
    max-height: 50px;
    max-width: 230px;
  }

  .remove {
    grid-area: remove;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .favourite__removebtn {
    grid-column-end: initial;
    height: 50px;
    width: 50px;
  }

  .favourite__price {
    grid-area: price;
    display: flex;
    margin-left: ${spacing.base_4}px;
    margin-top: ${spacing.base_2}px;
    @media ${mediumUp} {
      justify-content: flex-end;
      margin-left: 0px;
      margin-top: 0px;
    }
  }

  .favourite__content {
    grid-area: title;
    margin-left: ${spacing.base_4}px;

    h2,
    .favourite__brand {
      margin-bottom: ${spacing.base_2}px;
    }

    .favourite__link {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .favourite__brand {
    text-transform: uppercase;
    font-weight: normal;
    color: ${colors.darkGrey};
    font-size: ${typography.sizes.medium};
  }

  .favourite__oos-msg {
    text-transform: uppercase;
    font-weight: bold;
    color: black;
    font-size: ${typography.sizes.medium};
  }

  .favourite__imagewrapper {
    grid-area: imagewrapper;
    padding-bottom: 100%;
    height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: 1px solid ${colors.borderGrey};
    transition: border-color 100ms ease-in;
  }

  .instock {
    .favourite__imagewrapper {
      &:hover {
        border-color: ${colors.primary};
      }
    }
  }

  .favourite__image {
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    transform: translate(-50%, -50%);
    object-fit: contain;
    flex-shrink: 0;
    max-height: calc(100% - 40px);
    max-width: calc(100% - 40px);
    margin: 20px;
  }
`
